import { Typography } from "@mui/material";
import TableActionMenu from "./TableActionMenu";
import { format } from "date-fns";

export const generateCleverColumns = (actions) => {
  return [
    {
      name: "Date",
      selector: (row) => row?.createdAt,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {/* {new Date(row?.createdAt)} */}
          {row?.createdDate?.seconds
            ? format(
                new Date(row?.createdDate?.seconds * 1000),
                "E MMM dd yyyy"
              )
            : "-"}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Clever Page",
      selector: (row) => row?.page,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row?.cleverPageName}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Snippet Title",
      selector: (row) => row?.snippetName,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.snippetName}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Snippet Views",
      selector: (row) => row.snippetViews,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.snippetViews}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Article Views",
      selector: (row) => row.articleViews,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {/* {new Date(row?.startingDate?.seconds * 1000).toDateString()} */}
          {row.articleViews}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Helpfull Yes",
      selector: (row) => row.yesCount,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {/* {new Date(row?.endDate?.seconds * 1000).toDateString()} */}
          {row.yesCount}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Helpfull No",
      selector: (row) => row.noCount,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {/* {new Date(row?.reviewDate?.seconds * 1000).toDateString()} */}
          {row.noCount}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Active Status",
      selector: (row) => row.isActive,
      cell: (row) => (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            paddingX: "8px",
            paddingY: "4px",
            backgroundColor: row.isActive ? "#2DC58C" : "#2F80ED",
            borderRadius: "2px",
            color: "white",
            whiteSpace: "nowrap",
          }}
        >
          {row.isActive ? "Active" : "Inactive"}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Action",
      cell: (row) => {
        const updatedActions = actions?.filter((action)=>{
          if(row?.isActive&&action?.actionName!=="Activate"){
            return action;
          }
          else if(!row?.isActive&&action?.actionName!=="Deactivate"){
            return action;
          }
        })
        return <TableActionMenu row={row} updatedActionList={updatedActions} />;
      },
      // sortable: false,
      // hide: "md",
    },
  ];
};
